import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export function QrCode({ value, size = 220 }: { value: string; size?: number }) {
  const [src, setSrc] = useState<string>('');

  useEffect(() => {
    let alive = true;
    QRCode.toDataURL(value, { width: size, margin: 1, color: { dark: '#111114', light: '#f5f3ea' } })
      .then((url) => {
        if (alive) setSrc(url);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [value, size]);

  return (
    <div className="qr-box" style={{ background: '#f5f3ea', padding: 12, borderRadius: 12, display: 'inline-block' }}>
      {src ? <img src={src} width={size} height={size} alt="QR-код комнаты" /> : <div style={{ width: size, height: size }} />}
    </div>
  );
}
